import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import navbarData from '../data/NavbarData'
import * as ai from 'react-icons/ai';
import * as bs from 'react-icons/bs';
import Axios from 'axios';
import Share from './SheetHeader/Share';
import Lock from './SheetHeader/Lock';
import Public from './SheetHeader/public';
import SheetMenus from './SheetHeader/SheetMenus';
import Publish from './SheetHeader/publish';
import {Helmet} from 'react-helmet';

export const ShareContext = React.createContext();

export default function Header(props) {

    const {documentId, viewer} = props;

    const [docx, setDocx] = useState(null);
    const [docName, setDocName] = useState("Untitled Doc");
    const [share, setShare] = useState(false);
    const [lock, setLock] = useState();
    const [publics, setPublic] = useState();
    const [publish, setPublish] = useState();

    //console.log(docx);

    useEffect(async () => {
        //console.log("Iam useEff");
        //! Fetching Document Contents FRom db
        const url = `https://docsserver.onrender.com/sheets/sheetDetails/${documentId}`;

        try
        {
            //console.log("Inside try");
            let res = await Axios.get(url);
            //console.log("---New DOcx Data --");
            //console.log(res.data);  
            if(res.data)
            {
                setDocx(res.data[0]);
                setLock(res.data[0].lock);
                setPublic(res.data[0].public);
                setPublish(res.data[0].publish);
                
                if((res.data[0].name) !== "")
                {
                    setDocName(res.data[0].name)
                }
            }
            else
            {
                //!Must be Handled 🔻
            }
        }
        catch(err)
        {
            //console.log(err);
        }

        if(docx == null)
        {
            shareSupport();
        }

    }, [documentId])

    //! Share Support
    async function shareSupport()
    {
        const url = `https://docsserver.onrender.com/sheets/sheetDetails/${documentId}`;

        try
        {
            //console.log("Inside try");
            let res = await Axios.get(url);
            // console.log("---New DOcx Data --");
            // console.log(res.data);
            if(res.data)
            {
                setDocx(res.data[0]);
                setLock(res.data[0].lock);
                setPublic(res.data[0].public);
                setPublish(res.data[0].publish);

                if((res.data[0].name) !== "")
                {
                    setDocName(res.data[0].name)
                }
            }
            else
            {
                //!Must be Handled 🔻
            }
        }
        catch(err)
        {
            //console.log(err);
        }

    }

    const [showMenu, setShowMenu] = useState(false);

    async function UpdateDocxName(e)
    {
        const url = 'https://docsserver.onrender.com/sheets/updateName';
        let name = e.target.value;
        //console.log(name);
        setDocName(name);

        try
        {
            const res = await Axios.patch(url, {name: name, docUrl: docx.urlkey})
            //console.log(res);
        }
        catch(err)
        {
            //console.log(err);
        }
    }


  return (
    <nav className='bg-gray-100 sticky top-0 z-10 w-full'>

        <Helmet>
            <title>{docx?docx.name:""} Docx</title>
        </Helmet>

        <div className='py-2 px-6 mx-auto border'>
            <div className='flex justify-between items-center'>
                {/* //! Primary and Logo Nav */}
                <div className='flex items-center'>
                    <div className='flex items-center mr-4 space-x-2'>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-blue-500" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
                        </svg>
                        {/* <span className=''>Docx</span> */}
                    </div>


                    <div className='hidden md:block space-x-6'>
                       {viewer?<input type="text" value={docName}  className="p-2 rounded-md" onChange={(e) => UpdateDocxName(e)} readOnly/>:<input type="text" value={docName}  className="p-2 rounded-md" onChange={(e) => UpdateDocxName(e)} />}
                    </div>

                    {/* <div className='ml-5'>
                        <ai.AiOutlineCloudSync size={22} className="text-gray-600"/>
                        <bs.BsFillCloudCheckFill size={22} className="text-gray-600"/>
                    </div> */}

                    <SheetMenus docx = {docx} shareSupport={shareSupport} />
                </div>

                {/* //! SECONDARY Nav */}
                <div className='hidden md:flex items-center space-x-3'>
                    {lock?"":<><Publish status={publish} docId = {documentId} shareSupport={shareSupport}/><Public status={publics} docId = {documentId} shareSupport={shareSupport} /></>}
                    <Lock docId = {documentId} status={lock} shareSupport={shareSupport} />
                    {/* <button><bs.BsPeopleFill size={30} className='text-black border-2 rounded-full' /></button> */}
                    <button className='flex items-center bg-blue-600 text-white p-2 rounded hover:bg-blue-800 transition-all shadow font-semibold' onClick={() => setShare(!share)}><svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
                    </svg> Share</button>

                    <Link to={"/"} className='bg-gray-600 text-white p-2 rounded hover:bg-gray-800 transition-all shadow'><ai.AiOutlineHome size={24} /></Link>
                </div>

                {/* //TODO: Mobile NAV */}
                <div className='md:hidden flex items-center' onClick={() => setShowMenu(!showMenu)}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
                </svg>
                </div>
            </div>

            {showMenu? <div className='md:hidden mt-2'>
                {navbarData.map((n, index) => {
                    return(
                        <Link key={index} to={''} className='block px-3 py-2'>{n.name}</Link>
                    )
                })}
            </div>:""}
        </div>

        <ShareContext.Provider value={{share: share, setShare: setShare}}>
            {share?<Share docx={docx} shareSupport={shareSupport} viewer={viewer} />:""}
        </ShareContext.Provider>
    </nav>
  )
}
